import React, { useState, useEffect } from "react";
import "./index.css";
import logoSymbol from "../../../../assets/logo-light-symbol.png";
import logo from "../../../../assets/logo-light.png";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";

const STORE_URL = "https://loja.orionsinais.com.br";

const NAV_LINKS = [
  { href: STORE_URL, text: "Loja" },
  { href: "/blog", text: "Blog" },
  { href: "/#orion__landing-presentation", text: "Como funciona?" },
  { href: "/#orion__features-section", text: "Benefícios" },
  { href: "/#orion__plan-section", text: "Preços" },
  { href: "/#orion__faq-section", text: "Dúvidas" },
  { href: "/sobre-nos", text: "Quem somos?" },
];

function Navbar() {
  const breakpoint = 900;
  const [isMobile, setIsMobile] = useState(window.innerWidth <= breakpoint);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  useEffect(() => {
    let resizeTimer;
    const handleResize = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        requestAnimationFrame(() => {
          setIsMobile(window.innerWidth <= breakpoint);
        });
      }, 100);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      clearTimeout(resizeTimer);
    };
  }, []);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  const NavLinks = ({ mobile }) => (
    <ul className={mobile ? "orion__landing-navbar-sidebar" : ""}>
      {mobile && (
        <li>
          <XMarkIcon className="orion__lp-menu-icon" onClick={toggleSidebar} />
        </li>
      )}
      {NAV_LINKS.map(({ href, text }, index) => (
        <li key={index}>
          <a href={href} onClick={() => mobile && toggleSidebar()}>
            {text}
          </a>
        </li>
      ))}
      {mobile && (
        <li>
          <NavAuth />
        </li>
      )}
    </ul>
  );

  const NavAuth = () => (
    <div className="orion__navbar-buttons">
      <a className="link" href="/login">
        Entrar
      </a>
      <a className="orion__default-button" href="/cadastro">
        Cadastre-se
      </a>
    </div>
  );

  return (
    <header className="orion__landing-navbar">
      <a href="/">
        <img
          alt="Logo da Orion sinais"
          src={isMobile ? logo : logo}
          className="orion__landing-nav-logo"
        />
      </a>

      <nav>
        {isMobile ? (
          <>
            {isSidebarOpen && <NavLinks mobile />}
            <Bars3Icon
              className="orion__lp-menu-icon"
              onClick={toggleSidebar}
            />
          </>
        ) : (
          <div className="orion__lp-navbar-items">
            <NavLinks />
            <NavAuth />
          </div>
        )}
      </nav>
    </header>
  );
}

export default Navbar;
